<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.75 9.24434C4.75 9.10627 4.86193 8.99434 5 8.99434H8.00941C8.72413 8.99434 9.31123 8.4479 9.3757 7.75H14.4138C14.4782 8.4479 15.0653 8.99434 15.7801 8.99434H19C19.1381 8.99434 19.25 9.10627 19.25 9.24434V17C19.25 17.1381 19.1381 17.25 19 17.25H5C4.86193 17.25 4.75 17.1381 4.75 17V9.24434Z" fill="#505050" stroke="#505050" stroke-width="1.5" stroke-linejoin="bevel"/>
        <circle cx="12" cy="13" r="2.25" fill="#505050" stroke="white" stroke-width="1.5"/>
    </svg>
</template>

<script setup lang="ts">
</script>